import React, { createContext, useContext, useState } from 'react';

const VoiceWidgetContext = createContext();

export const useVoiceWidget = () => {
    const context = useContext(VoiceWidgetContext);
    if (!context) {
        throw new Error('useVoiceWidget must be used within a VoiceWidgetProvider');
    }
    return context;
};

export const VoiceWidgetProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openWidget = () => setIsOpen(true);
    const closeWidget = () => setIsOpen(false);
    const toggleWidget = () => setIsOpen(prev => !prev);

    return (
        <VoiceWidgetContext.Provider value={{ isOpen, openWidget, closeWidget, toggleWidget, setIsOpen }}>
            {children}
        </VoiceWidgetContext.Provider>
    );
};
